import styles from './ModuleWrapper.module.css';

function ModuleWrapper({children, menu, logout, hasContentBorder}) {
  const contentClassName = [styles.content];
  if (hasContentBorder) {
    contentClassName.push(styles.hasContentBorder);
  }
  return (
    <div className={styles.wrapper}>
      <div className={styles.menuContainer}>
        <div className={styles.menu}>{menu}</div>
        <button className={styles.logoutButton} onClick={logout}>Выйти</button>
      </div>
      <div className={contentClassName.join(' ')}>{children}</div>
    </div>
  );
}

export default ModuleWrapper;
